'use client'

import { useState } from 'react'
import { Accordion, Divider, Text } from '@vinted/web-ui'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'

const TRANSLATION_PREFIX = 'business.homepage.faq'

const ACCORDION_IDS = {
  IS_FREE: 0,
  BOTH_ACCOUNTS: 1,
  WILL_ITEMS_MOVE: 2,
  WHAT_POLICIES: 2, // Same ID as WILL_ITEMS_MOVE since they're conditionally rendered
  DETAILS_VISIBILITY: 3,
  WHAT_SELL: 4,
}

const BusinessAccountsFaq = () => {
  const translate = useTranslate(TRANSLATION_PREFIX)
  const { user } = useSession()
  const isLoggedIn = !!user

  const [isAccordionExpandedMap, setIsAccordionExpandedMap] = useState<Record<number, boolean>>({})

  const handleToggle = (id: number) => (isExpanded: boolean) => {
    setIsAccordionExpandedMap(prev => ({
      ...prev,
      [id]: isExpanded,
    }))
  }

  return (
    <SeparatedList separator={<Divider />}>
      <Accordion
        title={translate('is_free.title')}
        content={<Text as="span" text={translate('is_free.body')} html />}
        headerId="accordion_is_free_header"
        bodyId="accordion_is_free_body"
        isExpanded={isAccordionExpandedMap[ACCORDION_IDS.IS_FREE] || false}
        onToggle={handleToggle(ACCORDION_IDS.IS_FREE)}
      />
      <Accordion
        title={translate('both_accounts.title')}
        content={<Text as="span" text={translate('both_accounts.body')} html />}
        headerId="accordion_both_accounts_header"
        bodyId="accordion_both_accounts_body"
        isExpanded={isAccordionExpandedMap[ACCORDION_IDS.BOTH_ACCOUNTS] || false}
        onToggle={handleToggle(ACCORDION_IDS.BOTH_ACCOUNTS)}
      />
      {isLoggedIn ? (
        <Accordion
          title={translate('will_items_move.title')}
          content={<Text as="span" text={translate('will_items_move.body')} html />}
          headerId="accordion_will_items_move_header"
          bodyId="accordion_will_items_move_body"
          isExpanded={isAccordionExpandedMap[ACCORDION_IDS.WILL_ITEMS_MOVE] || false}
          onToggle={handleToggle(ACCORDION_IDS.WILL_ITEMS_MOVE)}
        />
      ) : (
        <Accordion
          title={translate('what_policies.title')}
          content={<Text as="span" text={translate('what_policies.body')} html />}
          headerId="accordion_what_policies_header"
          bodyId="accordion_what_policies_body"
          isExpanded={isAccordionExpandedMap[ACCORDION_IDS.WHAT_POLICIES] || false}
          onToggle={handleToggle(ACCORDION_IDS.WHAT_POLICIES)}
        />
      )}
      <Accordion
        title={translate('details_visibility.title')}
        content={<Text as="span" text={translate('details_visibility.body')} html />}
        headerId="accordion_details_visibility_header"
        bodyId="accordion_details_visibility_body"
        isExpanded={isAccordionExpandedMap[ACCORDION_IDS.DETAILS_VISIBILITY] || false}
        onToggle={handleToggle(ACCORDION_IDS.DETAILS_VISIBILITY)}
      />
      <Accordion
        title={translate('what_sell.title')}
        content={<Text as="span" text={translate('what_sell.body')} html />}
        headerId="accordion_what_sell_header"
        bodyId="accordion_what_sellw_body"
        isExpanded={isAccordionExpandedMap[ACCORDION_IDS.WHAT_SELL] || false}
        onToggle={handleToggle(ACCORDION_IDS.WHAT_SELL)}
      />
    </SeparatedList>
  )
}

export default BusinessAccountsFaq
